import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class UserModel extends BaseModel {
  static urlPath = "users";

  @attr("string") email;
  @attr("string") name;
  @attr("string") namePrefix;
  @attr("string") phone;
  @attr("string") username;
  @attr("date") dateOfBirth;
  @attr("string") profilePicture;
}
